/* eslint-disable camelcase */
export interface Student {
  type: string;
  id: string;
  attributes: Attributes;
  relationships: Relationships;
  profilePicture:string;
}

export interface Attributes {
  name: Name;
  email: string;
  phone: string;
  brand: string;
  migrated: Migrated;
  address: Address;
  timezone: string;
  language_id: string;
  membership: Membership;
  profile: Profile;
  entitlements: Entitlement[];
  segment: any[];
  updated_at: Date;
  created_at: Date;
}

export enum Migrated {
  PURGED = 1, // old purged record to allow new one
  IN_RECORD_MIGRATION_IN_PROGRESS = 2, // opted manual transfer
  IN_RECORD_MIGRATED = 3, // opted manual transfer completed
}

export interface Address {
  country: string;
  city: string;
  region: string;
  postal: string;
}

export interface Entitlement {
  name: string;
  slug: string;
  source: string;
}

export interface Membership {
  name: string;
  slug: string;
  status: string;
  start_date: Date;
  end_date: Date;
  attained_on: Date;
  custom_attributes?: CustomAttributes;
}

export interface CustomAttributes {
  lt_faculty_slug: string;
  lt_course_slug: string;
}
export interface Name {
  first_name: string;
  last_name: string;
}

export interface Profile {
  age: string;
  gender: string;
  goals: string;
  lessons_per_week: number;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  latest_source: string;
  latest_utm_medium: string;
  latest_utm_campaign: string;
  offer_type: string;
  free_trial_days: number;
  course_picked: string;
  industry: string;
  degree: string;
  employment: string;
  predicted_ltv: number;
  partner_identifier?: string;
  sales_rep_id?: string;
  latest_compass_conversation?: string
}

export interface Relationships {
  registrations: Registrations;
  studentprofiles: Registrations;
  subscriptions: Registrations;
}

export interface Registrations {
  links: Links;
  data: Datum[];
}

export interface Datum {
  type: Type;
  id: string;
}

export enum Type {
  Registration = 'registration',
  Studentprofile = 'studentprofile',
}

export interface Links {
  related: string;
  self: string;
}
